<template>
  <div>
    <b-row>
      <b-col sm="4">
        <b-input type="text" placeholder="Type to search" v-model.trim="filter"></b-input>
      </b-col>
    </b-row><br/>
    <b-row>
      <b-col sm="12" md="12">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="getRecords" :fields="fields" :per-page="perPage" :current-page="currentPage" :filter="filter">
          <template v-slot:cell(sn)="data">
            {{ data.index + 1 + ((currentPage - 1) * perPage) }}
          </template>
          <template v-slot:cell(Turnover)="data">
            {{ format(data.item.Turnover, '0,0.00') }}
          </template>
          <template v-slot:cell(NetWin)="data">
            {{ format(data.item.NetWin, '0,0.00') }}
          </template>
          <template v-slot:cell(HouseEdge)="data">
            {{ format(data.item.HouseEdge, '0.00%') }}
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(getRecords)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import numeral from 'numeral'

export default {
  name: 'highpayout-detail-table',
  props: {
    details: {
      type: Array,
      default: []
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fields: [
        {key: 'sn', label: 'SN', thStyle: { width: '50px' }},
        {key: 'Username', label: 'Username'},
        {key: 'Turnover', label: 'Turnover', sortable: true},
        {key: 'NetWin', label: 'NetWin', sortable: true},
        {key: 'HouseEdge', label: 'House Edge (%)'}
      ],
      filter: '',
      currentPage: 1,
      perPage: 30
    }
  },
  computed: {
    getRecords: function () {
      return this.details
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount (items) {
      return items.length
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/report/risk/game/PayoutDetail.vue